import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import useOnboardingSx from '../../hooks/useOnboardingSx';
import { OBJECT_ACTIONS } from '../../utils/permissionGrouping';
import PermissionModuleAccordion from './PermissionModuleAccordion';

export default function ObjectPermissionsPanel({
  permissions = [],
  disabled = false,
  onChange,
}) {
  const sx = useOnboardingSx();

  if (!permissions.length) return null;

  const totalEnabled = permissions.reduce((sum, row) => sum + row.enabledCount, 0);
  const totalActions = permissions.reduce((sum, row) => sum + row.totalCount, 0);

  return (
    <PermissionModuleAccordion
      title="Data access (object level)"
      enabledCount={totalEnabled}
      totalCount={totalActions}
      defaultExpanded
    >
      {permissions.map((row) => (
        <Box key={row.id} sx={sx.permissionObjectCard}>
          <Box sx={sx.permissionObjectHeader}>
            <Typography variant="subtitle2" fontWeight={600}>
              {row.moduleLabel}
            </Typography>
            <Chip
              size="small"
              label={`${row.enabledCount}/${row.totalCount} actions`}
              sx={sx.permissionCountChip}
            />
          </Box>
          <Box sx={sx.permissionActionGrid}>
            {OBJECT_ACTIONS.map((action) => (
              <Box key={action.key} sx={sx.permissionActionItem}>
                <Typography variant="body2">{action.label}</Typography>
                <Switch
                  size="small"
                  checked={!!row[action.key]}
                  disabled={disabled}
                  onChange={(event) => onChange(row.id, action.key, event.target.checked)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </PermissionModuleAccordion>
  );
}
